var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_vm._v(" 试题管理（暂时为空） ")])}
var staticRenderFns = []

export { render, staticRenderFns }